import CampaignDetails from './campaign-details';
import GoogleAds from './GoogleAds';

export default {
  GoogleAds,
  CampaignDetails,
};
